import { LojistikFiyatArsiv } from "./lojistik-fiyat-arsiv";

export class MazotFiyatlarPage {
    currentPage: number;
    pageCount: number;
    pageSize: number;
    rowCount: number;
    firstRowOnPage: number;
    lastRowOnPage: number;
    private pResults: LojistikFiyatArsiv[];

    constructor(obj?: any) {
      if (obj == null) {
        return;
      }
      Object.assign(this, obj);
    }
  
    public get results(): LojistikFiyatArsiv[] {
      return this.pResults;
    }
  
    public set results(list: LojistikFiyatArsiv[]) {
      if (list != null) {
        this.pResults = list.map(t => new LojistikFiyatArsiv(t));
      }
    }
}
